// web/src/utils/formatters/formatDate.ts
import moment from 'moment';

const MONTH_ABBR_MIXED = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/** Pads a single number to 2 digits: 5 → "05" */
export const padDate = (n: number): string => String(n).padStart(2, '0');

/**
 * Formats a "YYYY-MM-DD" string to "25 Dec" (or "25 DEC" when upper=true).
 * Used for holiday date labels in the calendar UI.
 */
export const formatDayMonth = (dateStr: string, upper = false): string => {
  const [, month, day] = dateStr.split('-').map(Number);
  const abbr = MONTH_ABBR_MIXED[month - 1] ?? '';
  return `${day} ${upper ? abbr.toUpperCase() : abbr}`;
};

/**
 * Formats a date string to MM/DD/YYYY format
 * @param dateString The date string to format
 * @returns Formatted date string in MM/DD/YYYY format
 */
const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export default formatDate;

export const formatDateLong = (dateString: string): string => {
  return moment(dateString).format('MMM DD, YY');
};
